export default __webpack_public_path__ + "static/sf-longest-city-charter-575da3a97e4b179c37f071c58110c333.png";